import EvidenceModal from 'custom_modules/Tasks/TaskDetails/EvidenceModal';
import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from 'reactstrap';

import avatar5 from '../../assets/img/avatar_5.svg';
import arrowWhiteIcon from '../../assets/img/icons/arrow_right_white.svg';
import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../components/NoDataComponent/NoDataComponent';
import InfoTooltip from '../../components/Tooltip/InfoTooltip';
import {
  CommonFlex,
  CommonImage,
  CommonText,
  Container,
  RoundMiniImage,
  TableText,
} from '../../styledComponents/common';
import { MemberNameDiv } from '../../styledComponents/members';
import { TableItem } from '../../styledComponents/teams';
import {
  formatClockIn,
  getHours,
  getHoursWithSeconds,
  toHHMMSS,
} from '../../utils/helper';
import { CommImageNameComp } from '../Members/CommonComponents';
import { ExpandIcon, ProjectExpandButton } from '../Projects/projectsStyles';
import {
  ClockInOutTableHeader,
  ClockInOutTableMainRow,
  ClockInOutTableRow,
  ColoredTextWithValue,
} from './clockInOutStyles';

const ClockInOutTable = props => {
  const {
    isLoading,
    history,
    clockInOutList,
    startDate,
    endDate,
  } = props;
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [collapsedAttendanceIds, setCollapsedAttendanceIds] = useState(new Set());
  const startDateDayStartTimestamp = moment(startDate).startOf('day').unix();
  const endDateDayEndTimestamp = moment(endDate).endOf('day').unix();

  const { t } = useTranslation();
  console.log('clockInOutList', clockInOutList);

  const popupToggle = () => {
    setPopupOpen(!popupOpen);
  };
  const handleExpandAttendance = attendanceId => {
    setCollapsedAttendanceIds(prev => {
      const newSet = new Set(prev);
      if (newSet.has(attendanceId)) {
        newSet.delete(attendanceId);
      } else {
        newSet.add(attendanceId);
      }
      return newSet;
    });
  };
  return (
    <Container style={{ paddingBottom: '20px' ,overflowX:'auto'}}>
      {selectedImage && (
        <EvidenceModal
          isOpen={popupOpen}
          toggle={popupToggle}
          evidence={selectedImage}
        />
      )}
      {isLoading ? (
        <ComponentCircleLoader />
      ) : clockInOutList && clockInOutList.length > 0 ? (
        <>
          <ClockInOutTableHeader>
            <TableItem>
              <TableText>{t('member_name')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('location')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('date')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('clock_in')}</TableText>
            </TableItem>
            <TableItem>
              {/* <InfoTooltip
                mainText={t('clock_out')}
                toolTipText="Clock out occurs when the user stops the timer at the end of the day"
                title
                label
                top="-55px"
                tooltipPadding="5px 8px"
                infoSize="17px"
              /> */}
              <TableText>{t('clock_out')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('duration')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('clock_out_reason')}</TableText>
            </TableItem>
            {/* <TableItem>
              <TableText>{t('office')}</TableText>
            </TableItem> */}
            {/* <TableItem>
              <TableText>{t('image')}</TableText>
            </TableItem> */}
          </ClockInOutTableHeader>

          {clockInOutList &&
            clockInOutList.length > 0 &&
            clockInOutList.map((instance, index) => {
              const { employee, location, attendances } = instance;
              const attendanceId = `${employee.id}-${index}`;
              const isExpanded = !collapsedAttendanceIds.has(attendanceId);
              return (
                <>
                  <ClockInOutTableMainRow key={index}>
                    <TableItem>
                      <MemberNameDiv>
                        <CommImageNameComp
                          imgSource={employee.avatar || avatar5}
                          name={`${employee.first_name}${
                            employee.last_name ? ` ${employee.last_name}` : ``
                          }`}
                          size="36px"
                        />
                      </MemberNameDiv>
                    </TableItem>
                    {/* <TableItem>
                    <TableText name>
                      {employee && employee.user_code
                        ? employee.user_code
                        : '-'}
                    </TableText>
                  </TableItem> */}
                    {/* location */}
                    <TableItem>
                      <TableText name>
                        {location && location.name ? location.name : '-'}
                      </TableText>
                    </TableItem>
                    {/* date */}
                    <TableItem>
                      <TableText name>
                        {attendances &&
                        attendances[0] &&
                        attendances[0].clockin_timestamp
                          ? moment
                              .unix(
                                Math.max(
                                  attendances[0].clockin_timestamp,
                                  startDateDayStartTimestamp,
                                ),
                              )
                              .format('DD-MM-YYYY')
                          : '-'}
                      </TableText>
                    </TableItem>

                    {/* Clock In */}
                    <TableItem>
                      <TableText name>
                        <CommonFlex alignItems="flex-start" direction="column" gap="0px">
                          {attendances[0].clockin_timestamp ? formatClockIn(attendances[0].clockin_timestamp) : '-'}
                          <CommonText fontSize="10px" color="rgb(32, 190, 173)">
                            {attendances[0].clockin_timestamp &&
                              (moment
                                .unix(attendances[0].clockin_timestamp)
                                .isSame(moment(), 'day')
                                ? 'Today'
                                : attendances[0].clockin_timestamp <
                                    startDateDayStartTimestamp &&
                                  moment
                                    .unix(attendances[0].clockin_timestamp)
                                    .format('DD-MM-YYYY'))}
                            {!attendances[0].clockin_timestamp && '-'}
                          </CommonText>
                        </CommonFlex>
                        {/* {instance.attendance && instance.attendance.clockIn
                        ? moment
                            .unix(instance.attendance.clockIn.timestamp)
                            .format('LT')
                        : '-'} */}
                      </TableText>
                    </TableItem>
                    {/* Clock Out */}

                    <TableItem>
                      <TableText name>
                        {/* {instance.attendance && instance.attendance.clockOut
                        ? moment
                            .unix(instance.attendance.clockOut.timestamp)
                            .format('LT')
                        : '-'} */}
                        <CommonFlex alignItems="flex-start" direction="column" gap="0px">
                          {attendances[0].clockout_timestamp ? formatClockIn(attendances[0].clockout_timestamp) : '-'}
                          <CommonText fontSize="10px" color="rgb(32, 190, 173)">
                            {attendances[0].clockout_timestamp &&
                              (moment
                                .unix(attendances[0].clockout_timestamp)
                                .isSame(moment(), 'day')
                                ? 'Today'
                                : !moment
                                    .unix(attendances[0].clockout_timestamp)
                                    .isSame(
                                      moment.unix(
                                        Math.max(
                                          attendances[0].clockin_timestamp,
                                          startDateDayStartTimestamp,
                                        ),
                                      ),
                                      'day',
                                    ) &&
                                  moment
                                    .unix(attendances[0].clockout_timestamp)
                                    .format('DD-MM-YYYY'))}
                            {!attendances[0].clockout_timestamp && '-'}
                          </CommonText>
                        </CommonFlex>
                      </TableText>
                    </TableItem>
                    {/* duration */}
                    <TableItem>
                      <TableText name>
                        {attendances[0].clockout_timestamp &&
                        attendances[0].clockin_timestamp
                          ? getHoursWithSeconds(
                              toHHMMSS(
                                attendances[0].clockout_timestamp -
                                  attendances[0].clockin_timestamp,
                              ),
                            )
                          : '-'}
                      </TableText>
                    </TableItem>
                    {/* Clock Out Reason */}
                    <TableItem>
                      <TableText name>
                        {attendances[0] &&
                        attendances[0].clockout_timestamp &&
                        attendances[0].clock_out_reason &&
                        attendances[0].clock_out_reason !== '' ? (
                          <ColoredTextWithValue
                            reason={attendances[0].clock_out_reason}
                          >
                            {t(attendances[0].clock_out_reason)}
                          </ColoredTextWithValue>
                        ) : (
                          '-'
                        )}
                      </TableText>
                    </TableItem>
                    {/* expand button - show only if there are multiple attendances */}
                    <TableItem style={{ display: 'flex', justifyContent: 'end' }}>
                      {attendances && attendances.length > 1 && (
                        <ProjectExpandButton
                          margin="0"
                          onClick={() => handleExpandAttendance(attendanceId)}
                        >
                          <ExpandIcon
                            src={arrowWhiteIcon}
                            alt=""
                            open={isExpanded}
                          />
                        </ProjectExpandButton>
                      )}
                    </TableItem>

                    {/* <TableItem>
                    <TableText name>
                      {instance.employee &&
                      instance.employee.office &&
                      instance.employee.office.name
                        ? instance.employee.office.name
                        : '-'}
                    </TableText>
                  </TableItem> */}
                    {/* <TableItem>
                    {instance.attendance.clockIn &&
                      instance.attendance.clockIn.selfie && (
                        <CommonImage
                          height="46px"
                          width="36px"
                          style={{ cursor: `pointer` }}
                          onClick={() => {
                            setSelectedImage(
                              instance.attendance.clockIn.selfie,
                            );
                            popupToggle();
                          }}
                          src={instance.attendance.clockIn.selfie}
                        />
                      )}
                  </TableItem> */}
                  </ClockInOutTableMainRow>
                  {/* Expanded row showing additional attendance records */}
                  {isExpanded && attendances && attendances.length > 1 && (
                    <>
                      {attendances
                        .slice(1)
                        .map((attendance, attendanceIndex) => (
                          <ClockInOutTableRow
                            key={`${attendanceId}-${attendanceIndex}`}
                          >
                            <TableItem>
                              {/* Employee name only in first row, empty for expanded rows */}
                            </TableItem>
                            {/* location - empty for expanded rows */}
                            <TableItem></TableItem>
                            {/* date */}
                            <TableItem>
                              <TableText name>
                                {attendance && attendance.clockin_timestamp
                                  ? moment
                                      .unix(
                                        Math.max(
                                          attendance.clockin_timestamp,
                                          startDateDayStartTimestamp,
                                        ),
                                      )
                                      .format('DD-MM-YYYY')
                                  : '-'}
                              </TableText>
                            </TableItem>

                            {/* Clock In */}
                            <TableItem>
                              <TableText name>
                                <CommonFlex alignItems="flex-start" direction="column" gap="0px">
                                  {attendance.clockin_timestamp ? formatClockIn(attendance.clockin_timestamp) : '-'}
                                  <CommonText
                                    fontSize="10px"
                                    color="rgb(32, 190, 173)"
                                  >
                                    {attendance.clockin_timestamp &&
                                      (moment
                                        .unix(attendance.clockin_timestamp)
                                        .isSame(moment(), 'day')
                                        ? 'Today'
                                        : attendance.clockin_timestamp <
                                            startDateDayStartTimestamp &&
                                          moment
                                            .unix(attendance.clockin_timestamp)
                                            .format('DD-MM-YYYY'))}
                                    {!attendance.clockin_timestamp && '-'}
                                  </CommonText>
                                </CommonFlex>
                              </TableText>
                            </TableItem>

                            {/* Clock Out */}
                            <TableItem>
                              <TableText name>
                                <CommonFlex alignItems="flex-start" direction="column" gap="0px">
                                  {attendance.clockout_timestamp ? formatClockIn(attendance.clockout_timestamp) : '-'}
                                  <CommonText
                                    fontSize="10px"
                                    color="rgb(32, 190, 173)"
                                  >
                                    {attendance.clockout_timestamp > 0 &&
                                      (moment
                                        .unix(attendance.clockout_timestamp)
                                        .isSame(moment(), 'day')
                                        ? 'Today'
                                        : !moment
                                            .unix(attendance.clockout_timestamp)
                                            .isSame(
                                              moment.unix(
                                                Math.max(
                                                  attendance.clockin_timestamp,
                                                  startDateDayStartTimestamp,
                                                ),
                                              ),
                                              'day',
                                            ) &&
                                          moment
                                            .unix(attendance.clockout_timestamp)
                                            .format('DD-MM-YYYY'))}
                                    {!attendance.clockout_timestamp && '-'}
                                  </CommonText>
                                </CommonFlex>
                              </TableText>
                            </TableItem>

                            {/* duration */}
                            <TableItem>
                              <TableText name>
                                {attendance.clockout_timestamp &&
                                attendance.clockin_timestamp
                                  ? getHoursWithSeconds(
                                      toHHMMSS(
                                        attendance.clockout_timestamp -
                                          attendance.clockin_timestamp,
                                      ),
                                    )
                                  : '-'}
                              </TableText>
                            </TableItem>

                            {/* Clock Out Reason */}
                            <TableItem>
                              <TableText name>
                                {attendance.clockout_timestamp &&
                                attendance.clock_out_reason &&
                                attendance.clock_out_reason !== '' ? (
                                  <ColoredTextWithValue
                                    reason={attendance.clock_out_reason}
                                  >
                                    {t(attendance.clock_out_reason)}
                                  </ColoredTextWithValue>
                                ) : (
                                  '-'
                                )}
                              </TableText>
                            </TableItem>

                            {/* Empty cell for expand button alignment */}
                            <TableItem></TableItem>
                          </ClockInOutTableRow>
                        ))}
                    </>
                  )}
                </>
              );
            })}
        </>
      ) : (
        <NoDataComponent
          title="No Attendance In This Day!"
          padding="5vh 0"
          imageHeight="140px"
        />
      )}
    </Container>
  );
};

export default ClockInOutTable;
